import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Attach access token
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem('access_token');
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshing = null;

async function doRefresh() {
  const rt = localStorage.getItem('refresh_token');
  if (!rt) throw new Error('No refresh token');
  const resp = await axios.post(`${API}/auth/refresh`, { refresh_token: rt });
  localStorage.setItem('access_token', resp.data.access_token);
  localStorage.setItem('refresh_token', resp.data.refresh_token);
  return resp.data.access_token;
}

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const original = err.config || {};
    if (err.response?.status === 401 && !original._retry && localStorage.getItem('refresh_token') && !original.url?.includes('/auth/refresh')) {
      original._retry = true;
      try {
        refreshing = refreshing || doRefresh();
        const newToken = await refreshing;
        refreshing = null;
        original.headers.Authorization = `Bearer ${newToken}`;
        return api(original);
      } catch (_e) {
        refreshing = null;
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/admin/login')) {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = 'Something went wrong. Please try again.') {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join('; ');
  return e?.message || fallback;
}
